import styled from "styled-components";

export const NewsletterWrapper = styled.div`
  background-color: #edf1fc;
  width: 100%;
`;

export const NewsletterContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  padding-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 1400px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const NewsletterLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const NewsletterTitle = styled.h1`
  margin-bottom: 10px;
  color: #17224d;

  @media (max-width: 800px) {
    margin-right: 10%;
    margin-left: 10%;
  }
`;

export const NewsletterDescription = styled.h3`
  margin-bottom: 20px;
  text-align: left;
  color: #17224d;

  @media (max-width: 800px) {
    margin-right: 10%;
    margin-left: 10%;
  }
`;

export const NewsletterRight = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const NewsletterInputAndButton = styled.div`
  display: flex;
  align-items: center;
`;

export const NewsletterInput = styled.input`
  padding: 10px;
  margin-right: -5px;
  width: 90%;
  border-radius: 12px 0 0 12px;
  border: 1px solid #ccc;
`;

export const NewsletterButton = styled.div`
  padding: 10px 20px 10px 20px;
  background-color: #3393f0;
  color: white;
  font-size: 14px;
  border-radius: 0 12px 12px 0;
  cursor: pointer;
  text-align: center;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
